import { EVENTS } from '../../lib/constants';

const events = [
	EVENTS.SERVER_MSG,
	EVENTS.ALL_LINES_FINISHED,
	EVENTS.MODAL,
	EVENTS.ERROR_PAGE,
	EVENTS.SETTINGS_UPDATE,
	EVENTS.BONUS_ROUND_STATE,
	EVENTS.WIN_HIGHLIGHT,
	EVENTS.START_GAME,
	EVENTS.HAS_QUEST,
	EVENTS.FREESPIN,
	EVENTS.REEL_FINISHED,
	EVENTS.BET_PLACED,
	EVENTS.MAIN_LINE_FINISHED
];

export function addEventListeners(that) {
	for (let i = 0; i < events.length; i++) {
		window.addEventListener(events[i], that, false);
	}
}

export function removeEventListeners(that) {
	for (let i = 0; i < events.length; i++) {
		window.removeEventListener(events[i], that, false);
	}
}
